import { useTranslation } from 'react-i18next'
import './registration-success.scss'
import BasePage from 'pages/base-page/base-page.page'
import { BaseButton } from 'components'

const RegistrationSuccess: React.FC = () => {
  const { t } = useTranslation()
  return (
    <BasePage pageClass="edisu-page-registration-success">
      <div className="content ion-padding">
        <h2>{t('registration_success_title')}</h2>
        <p className="success-message">{t('registration_success_message')}</p>
        <div className="links">
          <a href="/login">
            <BaseButton label={t('go_to_profile')}></BaseButton>
          </a>
        </div>
      </div>
    </BasePage>
  )
}

export default RegistrationSuccess
